var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33.006h-.094C7.224.006 7.218 0 7.206 0h-3.75c-.013 0-.02.006-.032.006H3.33c-.275 0-.5.231-.5.513v9.219c0 .28.156.35.356.15L4.98 8.05a.49.49 0 0 1 .706 0L7.48 9.887c.194.2.356.132.356-.15V.52A.518.518 0 0 0 7.33.006Z",
    fill: "#E8B082"
  })));
};
export default SvgBookmark;